<template>
  <v-card color="grey lighten-3">
    <v-card-text class="py-4 pl-5 pr-4">
      <v-layout
        row
        wrap
        v-for="(info, index) in promotion_products"
        :key="index"
      >
        <v-flex xs12 sm2 md1 class="promo-title">
          <span class="style-title-promo"
            >Product {{ promotion_products.indexOf(info) + 1 }} :</span
          >
        </v-flex>

        <v-flex xs5 sm4 md5 class="pr-4">
          <v-autocomplete
            v-model="promotion_products[index].store"
            :items="store_list_free"
            :loading="isLoadingStore"
            color="black"
            hide-no-data
            hide-selected
            item-text="store_name_th"
            item-value="store_id"
            label="Search store"
            placeholder="Select store"
            @change="selectStore($event, index)"
            :rules="[(v) => !!v || 'Store is required']"
            v-if="form.promotion_order_type == 3"
            :disabled="isEditPromotion"
          ></v-autocomplete>
          <v-autocomplete
            v-model="promotion_products[index].store"
            :items="store_list"
            :loading="isLoadingStore"
            color="black"
            hide-no-data
            hide-selected
            item-text="store_name_th"
            item-value="store_id"
            label="Search store"
            placeholder="Select store"
            @change="selectStore($event, index)"
            :rules="[(v) => !!v || 'Store is required']"
            :disabled="isEditPromotion"
            v-else
          ></v-autocomplete>
        </v-flex>
        <v-flex xs5 sm4 md5 class="pl-4">
          <v-autocomplete
            v-model="promotion_products[index].product"
            :items="product_list[index]"
            :loading="isLoadingProduct[index]"
            color="black"
            hide-no-data
            hide-selected
            item-text="product_name_th"
            item-value="product_id"
            label="Search product"
            placeholder="Select product"
            :rules="[(v) => !!v || 'Product is required']"
            :disabled="isEditPromotion"
          ></v-autocomplete>
        </v-flex>
        <v-flex xs2 sm2 md1 class="text-xs-center pt-4" v-if="!isEditPromotion">
          <v-icon
            medium
            color="green"
            :disabled="isLoadingProduct.includes(true)"
            @click="moreStore()"
            v-if="index == 0"
            >add_box</v-icon
          >
          <v-icon
            medium
            color="red"
            :disabled="isLoadingProduct.includes(true)"
            @click="lessStore(index)"
            v-else
            >indeterminate_check_box</v-icon
          >
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: ["promotion_products", "form", "province"],
  data() {
    return {
      isLoadingStore: false,
      isLoadingProduct: [],
      product_list: [],
    };
  },
  computed: {
    ...mapGetters({
      store_list_free: "fetchStoreBack/autocompleteStoreFreedelivery",
      store_list: "fetchStoreBack/autocompleteStore",
      isEditPromotion: "isEditPromotion",
    }),
  },
  methods: {
    moreStore() {
      this.promotion_products.push({ store: null, product: null });
    },
    lessStore(index) {
      this.isLoadingProduct.splice(index, 1);
      this.product_list.splice(index, 1);
      this.promotion_products.splice(index, 1);
    },
    // async fetchStore() {
    //   if (this.isLoadingStore) return;
    //   this.isLoadingStore = true;
    //   await this.$store.dispatch("fetchStoreBack/getStoreList");
    //   this.isLoadingStore = false;
    // },
    selectStore(store_id, index) {
      this.promotion_products[index].product = null;
      this.fetchProduct(store_id, index);
    },
    async fetchProduct(store_id, index) {
      this.product_list[index] = [];
      this.isLoadingProduct[index] = true;
      let product_list_data = await this.$store.dispatch(
        "fetchOrderDetailBack/getProductByStore",
        store_id
      );
      this.product_list.splice(index, 1, product_list_data);
      this.isLoadingProduct.splice(index, 1, false);
    },
    async initialzation() {
      // this.fetchStore();
      for (let key in this.promotion_products) {
        if (this.promotion_products[key].store != null) {
          this.fetchProduct(this.promotion_products[key].store, key);
        }
      }
    },
  },

  created() {
    this.initialzation();
  },
};
</script>

<style>
</style>
